module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card-title', [_c('v-row', {
    staticStyle: {
      "justify-content": "right",
      "margin-top": "-110px",
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.CC,
      "item-value": "id",
      "item-text": function (item) { return item.firstName + ' ' + item.lastName; },
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "CC"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.cc),
      callback: function($$v) {
        _vm.$set(_vm.filters, "cc", $$v)
      },
      expression: "filters.cc"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Pending")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.pending))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Valid")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.verified))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "sm6": "",
      "xs12": "",
      "pa-3": ""
    }
  }, [_c('v-card', {
    staticClass: "small-box",
    attrs: {
      "dark": "",
      "color": "#363636",
      "min-height": "145px"
    }
  }, [_c('v-card-title', {
    staticClass: "title card-title one-line"
  }, [_vm._v("Invalid")]), _vm._v(" "), _c('v-card-text', [_c('h3', [_vm._v(_vm._s(_vm.totalValues.unverified))])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "flex-end",
      "width": "100%",
      "padding-top": "12px",
      "gap": "12px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  TikTok Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.tiktokFollowers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "from", $$v)
      },
      expression: "filters.tiktokFollowers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.tiktokFollowers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "to", $$v)
      },
      expression: "filters.tiktokFollowers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isTikTokEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isTikTokEmpty", $$v)
      },
      expression: "filters.isTikTokEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchTikTokFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  IG Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "from", $$v)
      },
      expression: "filters.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "to", $$v)
      },
      expression: "filters.followers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isIgEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isIgEmpty", $$v)
      },
      expression: "filters.isIgEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchIGFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  Rate "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Content Type\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.contentTypes,
      "item-text": "title",
      "item-value": "value"
    },
    model: {
      value: (_vm.filters.contentType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "contentType", $$v)
      },
      expression: "filters.contentType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.filters.rateCurrency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCurrency", $$v)
      },
      expression: "filters.rateCurrency"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "from", $$v)
      },
      expression: "filters.rate.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "to", $$v)
      },
      expression: "filters.rate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  Age "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      Min Age\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.age.min),
      callback: function($$v) {
        _vm.$set(_vm.filters.age, "min", $$v)
      },
      expression: "filters.age.min"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      Max Age\n                      "), _c('v-text-field', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.age.max),
      callback: function($$v) {
        _vm.$set(_vm.filters.age, "max", $$v)
      },
      expression: "filters.age.max"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.countries,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.rateCardLabels,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Main Category"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.mainCategory),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mainCategory", $$v)
      },
      expression: "filters.mainCategory"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "items": _vm.statuses,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Status"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  })], 1)]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "width": "100%",
      "justify-content": "right"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "margin-left": "-25px"
    },
    attrs: {
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Sort By\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.sortColumns
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  })], 1), _vm._v(" "), (_vm.isSortCurrency) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.sort.currency),
      callback: function($$v) {
        _vm.$set(_vm.sort, "currency", $$v)
      },
      expression: "sort.currency"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Type\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-20px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "id": "rate-card-data-table",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]
      }
    }, {
      key: "item.email",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.email) + "\n          ")])]
      }
    }, {
      key: "item.dateOfBirth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n            " + _vm._s(item.dateOfBirth ? _vm.utils.formatCustomDate(item.dateOfBirth, 'MMM, YYYY') : '') + "\n          ")])]
      }
    }, {
      key: "item.ethnicity",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.ethnicity && item.ethnicity !== 'Others' ? item.ethnicity : '') + "\n            " + _vm._s(item.otherEth ? item.otherEth : '') + "\n          ")])]
      }
    }, {
      key: "item.country",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.country) + "\n          ")])]
      }
    }, {
      key: "item.city",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.city) + "\n          ")])]
      }
    }, {
      key: "item.gender",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.gender) + "\n          ")])]
      }
    }, {
      key: "item.contactNo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.contactNo) + "\n          ")])]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.instagramHandle) ? _c('social-handle', {
          attrs: {
            "isInstagram": true,
            "instagramHandle": item.instagramHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.igFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.igFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.tiktokHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.tiktokHandle) ? _c('social-handle', {
          attrs: {
            "isTikTok": true,
            "tiktokHandle": item.tiktokHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.tiktokFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.tiktokFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.cc",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.sourceID) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.CC.find(function (cc) { return cc.id === item.sourceID; }) ? _vm.CC.find(function (cc) { return cc.id === item.sourceID; }).firstName + ' ' + _vm.CC.find(function (cc) { return cc.id === item.sourceID; }).lastName : '') + "\n            ")]) : _vm._e()])]
      }
    }, {
      key: "item.youtube",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'youtube')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'youtube'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'youtube')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.facebook",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'facebook')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'facebook'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-facebook")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'facebook')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.twitch",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'twitch')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'twitch'),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getHandlePreview(item, 'twitch')))])]) : _vm._e()])]
      }
    }, {
      key: "item.igStory",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igStoryCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igStory)))]) : _vm._e()])]
      }
    }, {
      key: "item.igPost",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igPostCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igPost)))]) : _vm._e()])]
      }
    }, {
      key: "item.igCarousel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igCarouselCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igCarousel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igVideoCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igVideo)))]) : _vm._e()])]
      }
    }, {
      key: "item.igReel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igReelCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igReel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.igRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.igRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.tiktok",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.tiktokCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.tiktok)))]) : _vm._e()])]
      }
    }, {
      key: "item.tiktokRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.tiktokRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.tiktokRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.eventAppearance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.eventAppearanceCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.eventAppearance)))]) : _vm._e()])]
      }
    }, {
      key: "item.loadingFee",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.loadingFeeCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.loadingFee)))]) : _vm._e()])]
      }
    }, {
      key: "item.uploadMediaKit",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, _vm._l((item.pricingDecks), function(deck, idx) {
          return _c('v-btn', {
            key: idx,
            attrs: {
              "small": "",
              "text": "",
              "color": "secondary",
              "href": deck.url,
              "target": "_blank"
            }
          }, [_vm._v("\n              View Media\n            ")])
        }), 1)]
      }
    }, {
      key: "item.preferredCampaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.keywords || item.keywords.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.keywords), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.keywords),
            expression: "item.keywords"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.keywords && item.keywords.length > 1),
                  expression: "item.keywords && item.keywords.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Preferred Campaigns / Genre")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.keywords), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest))])
        })], 2)], 1)], 1)], 2)]
      }
    }, {
      key: "item.labels",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.labels || item.labels.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.labels), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.labels),
            expression: "item.labels"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.labels && item.labels.length > 0),
                  expression: "item.labels && item.labels.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Labellings")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.labels), function(label, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        })], 2)], 1)], 1), _vm._v(" "), _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mb-1 pa-0",
                attrs: {
                  "color": "secondary",
                  "small": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("edit")]), _vm._v("  Label\n                ")], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('div', [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Main Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.mainCategories),
            callback: function($$v) {
              _vm.$set(item, "mainCategories", $$v)
            },
            expression: "item.mainCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Sub Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "multiple": "",
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.subCategories),
            callback: function($$v) {
              _vm.$set(item, "subCategories", $$v)
            },
            expression: "item.subCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1)], 1)])], 1)], 2)]
      }
    }, {
      key: "item.aboutYou",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.aboutYou || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.aboutYou))
          }
        })])], 1)]
      }
    }, {
      key: "item.loadContent",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.loadContent) + "\n            " + _vm._s(item.loadContentText) + "\n          ")])]
      }
    }, {
      key: "item.giftBrand",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.giftBrand) + "\n          ")])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.verify === true) ? _c('v-chip', {
          attrs: {
            "color": "primary",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("\n              Valid\n            ")]) : (item.verify === false) ? _c('v-chip', {
          attrs: {
            "color": "error",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("\n              Invalid\n            ")]) : _c('v-chip', {
          attrs: {
            "color": "secondary",
            "text-color": "white",
            "small": ""
          }
        }, [_vm._v("\n              Pending\n            ")])], 1)]
      }
    }, {
      key: "item.updatedAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "105px!important"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.utils.formatCustomDate(item.updatedAt, 'DD-MM-YYYY')) + "\n          ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('div', {
          staticStyle: {
            "display": "flex",
            "gap": "5px"
          }
        }, [_c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Details"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "success",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.openVerifyDialog(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Verify"
          }
        }, [_vm._v("mdi-check-circle")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": "",
            "disabled": item.accountExist
          },
          on: {
            "click": function($event) {
              return _vm.openResetDialog(item)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "secondary"
                }
              }, on), [_vm._v("mdi-account-plus")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Onboard to IMS")])])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Rate Card",
            "color": "error",
            "text": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteRateCard(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)])]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)], 1), _vm._v(" "), (_vm.viewData) ? _c('view-modal-dialog', {
    attrs: {
      "value": _vm.viewDialog,
      "data": _vm.viewData
    },
    model: {
      value: (_vm.viewDialog),
      callback: function($$v) {
        _vm.viewDialog = $$v
      },
      expression: "viewDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('verify-dialog', {
    attrs: {
      "item": _vm.verifyData
    },
    on: {
      "verified": _vm.handleVerified
    },
    model: {
      value: (_vm.verifyDialog),
      callback: function($$v) {
        _vm.verifyDialog = $$v
      },
      expression: "verifyDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Ratecard Forms",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('inf-onboard-password-modal', {
    attrs: {
      "influencer": _vm.viewData
    },
    on: {
      "reload": _vm.onBoardSuccess
    },
    model: {
      value: (_vm.infPassResetDialog),
      callback: function($$v) {
        _vm.infPassResetDialog = $$v
      },
      expression: "infPassResetDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57948be5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/JoinCommunity/DataTable.vue
// module id = 2136
// module chunks = 0